<app-dialog class="reassign-kam-dialog" [loading]="isLoading">
  <ng-container dialog-title>Bitte ändern Sie den verantwortlichen KAM</ng-container>

  <ng-container dialog-content>
    <mat-checkbox [(ngModel)]="isMoveAll" class="container" (change)="selectAll(isMoveAll)" *ngIf="showCheckBox"
      >Alle Kommunen des verantwortlichen KAMs verschieben</mat-checkbox
    >
    <div class="message" *ngIf="municipality.message && municipality.message.length > 0">
      <span class="fa fa-exclamation-circle fa-2x warning-icon" aria-hidden="true"></span>
      {{ municipality.message }}
    </div>
    <div class="container">
      <div class="label margin-bottom">
        <label>Kommune:</label>
      </div>
      <div class="input margin-bottom" [ngSwitch]="isMoveAll">
        <ng-template [ngSwitchCase]="true">
          <cdk-virtual-scroll-viewport itemSize="10" class="example-viewport">
            <div *cdkVirtualFor="let item of municipalities" class="example-item">
              <mat-checkbox [(ngModel)]="item.selected">{{ item.name }} ({{ item.municipalityKey }})</mat-checkbox>
            </div>
          </cdk-virtual-scroll-viewport>
        </ng-template>
        <ng-template ngSwitchDefault>
          <span>{{ municipality.municipalityName }}</span>
        </ng-template>
      </div>
    </div>
    <div class="container">
      <div class="label">
        <label>Bisher: </label>
      </div>
      <div class="input">
        <span>{{ municipality.currKamName }}</span>
      </div>
    </div>
    <div class="container">
      <div class="label align-center">
        <label>Neu: </label>
      </div>
      <div class="input">
        <mat-form-field class="width-full" floatLabel="never">
          <input
            matInput
            class=""
            type="text"
            [formControl]="newKamControl"
            placeholder="Neuen KAM suchen"
            [matAutocomplete]="autoKam"
            [errorStateMatcher]="kamErrorMatcher"
          />
          <mat-error *ngIf="true">Dieser Name ist im System nicht vorhanden. Bitte wählen Sie einen bestehenden KAM aus. </mat-error>
          <mat-autocomplete autoActiveFirstOption #autoKam="matAutocomplete" [displayWith]="displayKam">
            <mat-option *ngFor="let kam of filteredKams | async" [value]="kam">
              <small>{{ kam.name }}</small> <span class="light-gray"> | </span> <small class="light-gray">{{ kam.email }}</small>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </ng-container>
  <ng-container dialog-actions class="margin-top">
    <button class="btn btn-outline-primary" (click)="cancel()">
      {{ 'module.userProfile.regionalAdmin.cancelButtonText' | translate }}
    </button>
    <button
      class="btn btn-outline-primary"
      [disabled]="!newKamControl.valid || (isMoveAll && selectedMunicipalities.length <= 0)"
      (click)="reassignMunicipalitiesToKam(selectedMunicipalities, municipality, newKamControl.value)"
    >
      {{ 'module.userProfile.regionalAdmin.saveButtonText' | translate }}
    </button>
  </ng-container>
</app-dialog>
